/**
 * Single source for the panel's interaction and animation timings.
 *
 * `animationDuration` has to agree with the CSS transition, so `usePanelPosition` publishes it
 * as the `--panel-animation-duration` custom property rather than the stylesheet declaring its
 * own copy — the value lives here and the CSS reads it.
 */
export const PANEL_TIMINGS = {
  /** Delay before opening on hover, guarding against accidental triggers */
  openDelay: 350,
  /** Window after a close in which the next open skips `openDelay`, for fast switching */
  skipDelay: 300,
  /** Grace period before closing once the pointer leaves */
  leaveDelay: 200,
  /** Open/close transition duration, mirrored into CSS */
  animationDuration: 200,
};

/**
 * How long the active panel's content stays mounted after closing. Sits just past
 * `animationDuration` so the content is not torn out mid-transition.
 */
export const PANEL_CLOSE_CLEANUP_MS = PANEL_TIMINGS.animationDuration + 50;
